import capitalize from 'lodash-es/capitalize';
import {
    BACK_TO_LIST_OF_GROUPS,
    DID_YOU_KNOW,
    GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS,
    HINT_FOR_GROUPS,
    LOCKED_GROUPS_LOCATIVE,
    RECENT_COMMENTS,
    RECENT_POSTS,
    SHORTENED_ORDER_BY,
    UNLOCKED_GROUPS_GENITIVE,
    YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR,
} from 'mk/autogenerated/translations/GroupSubscribedFeed.35648366945f435db6f25520d940e7fd'
import { groupsListUrl } from 'mk2/apps/blogs/urls';
import GroupFeedPosts from 'mk2/apps/groups/components/GroupFeedPosts';
import { OrderBy } from 'mk2/apps/groups/containers/GroupFeed/GroupFeedPage';
import { groupsSubscribedFeedUrl } from 'mk2/apps/groups/urls';
import AnnouncementBox, { BoxType } from 'mk2/components/AnnouncementBox';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import Failure from 'mk2/components/errors/Failure';
import Interpolate from 'mk2/components/Interpolate';
import MenuItem from 'mk2/components/menu/MenuItem';
import NoResults from 'mk2/components/NoResults';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import Menu from 'mk2/containers/Menu/Menu';
import { url } from 'mk2/helpers/urls';
import { isLoading, isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { parse, stringify } from 'query-string';
import React from 'react';
import { GROUP_SUBSCRIBED_FEED_MENU_ORDERBY } from './GroupSubscribedFeed.constants';
import styles from './GroupSubscribedFeed.mscss';
import { Props } from './GroupSubscribedFeedPage';

class GroupSubscribedFeed extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        const { loadingState, onScrollTo } = this.props;

        if (loadingState === LoadingState.SUCCESS_ON_SERVER) {
            const qs = parse(this.props.location.search);
            if (qs.scrollto) {
                onScrollTo(qs.scrollto);
            }
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const p = this.props;

        if (// zmenil sa feed (url) alebo page z feedu
            (p.location.pathname !== prevProps.location.pathname || p.pageRef !== prevProps.pageRef) &&
            // nevraciame sa cez 'Back'
            p.history.action !== 'POP' &&
            // a nacitali sme z cache (LoadingSwitch nespustil groupSubscribedFeedFetchTrigger)
            isSuccess(p.loadingState)
        ) {
            // defaultne sa scrollne na konci fetchGroupSubscribedFeed sagy, ale ta sa nespusti
            // tak vykonaj scroll side-effect
            const qs = parse(p.location.search);
            if (qs.scrollto) {
                p.onScrollTo(qs.scrollto);
            }
        }
    }

    public render() {
        const { loadingState, posts } = this.props;

        return (
            <div className={styles.GroupSubscribedFeed}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInitOrSuccess}
                    onRenderSuccess={this.renderInitOrSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={posts && posts.length > 0}
                />
            </div>
        );
    }

    private renderInitOrSuccess = () => {
        const {
            commentsCounts, complaintsCounts, complaintsOpened, errorMessage, loadingState, location,
            mobile, moderatorUsersByGroupId, numberOfPages, onChangeSticky, onCloseHint, onCommentDelete,
            onCommentToggleMenuMore, onDelete, onGroupFeedMenuOrderBy, onPostToggleMenuMore,
            onReport, orderBy, pageRef, permissions, posts, requestUser, showHint, staticContext, userAgent,
        } = this.props;

        return (
            <React.Fragment>

                {showHint && (
                    <AnnouncementBox
                        type={BoxType.Yellow}
                        hasDetailMessage
                        message={DID_YOU_KNOW}
                        detailMessage={(
                            <Interpolate
                                i18nKey={HINT_FOR_GROUPS}
                                UNLOCKED_GROUPS={(
                                    <>
                                        <b>{capitalize(UNLOCKED_GROUPS_GENITIVE)}</b> ( <i className={'fa fa-unlock-alt'} /> )
                                    </>
                                )}
                                LOCKED_GROUPS={(
                                    <>
                                        <b>{capitalize(LOCKED_GROUPS_LOCATIVE)}</b> ( <i className={'fa fa-lock'} /> )
                                    </>
                                )}
                            />
                        )}
                        onClose={onCloseHint}
                    />
                )}

                {isLoading(loadingState) || posts.length > 0 ? (
                    <div className={styles.GroupSubscribedFeed__orderBy}>
                        <span className={styles.GroupSubscribedFeed__orderBy__label}>{SHORTENED_ORDER_BY}:</span>
                        <Menu
                            menuId={GROUP_SUBSCRIBED_FEED_MENU_ORDERBY}
                            trigger={(
                                <Btn
                                    type={BtnType.GreyText}
                                    icon="fa-chevron-down"
                                    label={orderBy === 'posts' ? RECENT_POSTS : RECENT_COMMENTS}
                                    layout={BtnLayout.LabelIcon}
                                    onClick={onGroupFeedMenuOrderBy}
                                />
                            )}
                            triggerShadow={false}
                        >
                            <MenuItem
                                label={RECENT_POSTS}
                                onClick={this.handleOrderByPosts}
                            />
                            <MenuItem
                                label={RECENT_COMMENTS}
                                onClick={this.handleOrderByComments}
                            />
                        </Menu>
                    </div>
                ) : null}

                {isSuccess(loadingState) && posts.length === 0 && (
                    <NoResults
                        message={YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR}
                        detailMessage={GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS}
                        noIcon
                    />
                )}

                <div id="scrolltoFirstHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}

                <GroupFeedPosts
                    commentsCounts={commentsCounts}
                    complaintsCounts={complaintsCounts}
                    complaintsOpened={complaintsOpened}
                    errorMessage={errorMessage}
                    history={this.props.history}
                    loadingState={loadingState}
                    location={location}
                    mobile={mobile}
                    moderatorUsersByGroupId={moderatorUsersByGroupId}
                    numberOfPages={numberOfPages}
                    onCommentDelete={onCommentDelete}
                    onCommentToggleMenuMore={onCommentToggleMenuMore}
                    onChangeSticky={onChangeSticky}
                    onDelete={onDelete}
                    onGroupLeave={this.handleGroupLeave}
                    onHideGroupInFeed={this.handleHideGroupInFeed}
                    onPostToggleMenuMore={onPostToggleMenuMore}
                    onReport={onReport}
                    pageRef={pageRef}
                    permissions={permissions}
                    posts={posts}
                    requestUser={requestUser}
                    showGroup
                    showHashtagsBox={false}
                    showStrips
                    staticContext={staticContext}
                    userAgent={userAgent}
                />

                <div id="scrolltoLastHere" /> {/* musi byt vzdy vyrenderovane v DOMe, pouziva sa zo sagy */}
            </React.Fragment>
        );
    };

    private renderFailure = () => {
        const { errorMessage, staticContext } = this.props;

        return (
            <Failure
                staticContext={staticContext}
                errorMessage={errorMessage}
                onRetry={this.load}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_LIST_OF_GROUPS}
                        icon="fa-arrow-left"
                        link={url(groupsListUrl, { type: 'public' })}
                    />
                }
            />
        );
    };

    private load = () => {
        const { location, onLoad, orderBy, pageRef, posts } = this.props;
        const numPostsBeforeLoad = posts.length;
        onLoad(orderBy, pageRef, location, numPostsBeforeLoad);
    };

    private handleOrderByPosts = () => {
        this.handleOrderBy('posts');
    };

    private handleOrderByComments = () => {
        this.handleOrderBy('comments');
    };

    private handleOrderBy = (orderBy: OrderBy) => {
        if (this.props.orderBy === orderBy) {
            return;
        }

        const search = {
            ...((orderBy !== 'posts') ? { orderby: orderBy } : {}),
        };

        this.props.history.replace({
            pathname: groupsSubscribedFeedUrl,
            search: search ? stringify(search) : undefined,
        });
    };

    private handleGroupLeave = (groupId: number) => {
        const { onGroupLeave } = this.props;
        onGroupLeave(groupId, this.load);
    };

    private handleHideGroupInFeed = (groupId: number) => {
        const { onHideGroupInFeed } = this.props;
        onHideGroupInFeed(groupId, this.load);
    };
}

export default GroupSubscribedFeed;
